import CustomButton from '../../../common/components/CustomButton';
import CustomUpload from '../../../common/components/CustomUpload';
import PopupContainer from '../../../common/components/PopupContainer';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeUploadForm2OnvocalPopupFileName = 'song_vocal_on';

// 歌あり音源のアップロード（ポップアップ）
export default function KaraokeUploadForm2OnvocalPopup({
  getFiles,
  setFiles,
  getErrors,
  onClose,
} : {
  getFiles: (name: KaraokeUploadForm2OnvocalPopupFileName) => FileList|null,
  setFiles: (name: KaraokeUploadForm2OnvocalPopupFileName, value: FileList|null) => void,
  getErrors: (name: KaraokeUploadForm2OnvocalPopupFileName) => FieldValidationErrorsType,
  onClose: () => void,
}) {

  return (
    <PopupContainer title="歌あり音源" onClose={() => onClose()}>
      <div className="list__body">
        <p className="list__addtext">
          <p className="list__addtext_item">・歌あり音源をアップロードしてください。テロップ作成に使用します。</p>
          <br />
        </p>
        <div className="form__body">
          <dl>
            <dd>
              <CustomUpload
                type="audio"
                description="wav, mp3 (150MBまで)"
                files={getFiles('song_vocal_on')}
                onSelectFiles={(value) => setFiles('song_vocal_on', value)}
                onDeleteFiles={() => setFiles('song_vocal_on', null)}
                validationErrors={getErrors('song_vocal_on')}
              />
              <p className="text_info_on" />
            </dd>
          </dl>
        </div>
        <ul>
          <li className="bt w100">
            <CustomButton type="default" disabled={Object.keys(getErrors('song_vocal_on')).length > 0} onClick={() => onClose()}>設定する</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
